import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            大家都在聊的影视话题，看看哪个是你的菜
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group flex items-center gap-3 px-5 py-3 rounded-full border cursor-pointer transition-all duration-200 ${
                item.hot
                  ? 'border-accent-500/30 bg-accent-500/10 hover:bg-accent-500/20'
                  : 'border-background-200/60 bg-background-100 hover:border-primary-500/30 hover:bg-background-100/80'
              }`}
            >
              {item.hot && (
                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-fire-line text-[10px] text-background-50 w-3 h-3 flex items-center justify-center"></i>
                </span>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${item.hot ? 'text-accent-600' : 'text-foreground-700 group-hover:text-primary-500'}`}>
                {item.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}讨论</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}